module.exports = __webpack_public_path__ + "static/img/partition_img02.d86fb2b6.jpg";